import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Info from '../views/home/info'
/*import { checkPermission } from '../assets/js/util'*/
import Main from '@/views/Main'
Vue.use(VueRouter)

const routes = [{
        path: '/login',
        component: () =>
            import('../views/login.vue'),
        name: 'login'
    },
    {
        path: '/',
        component: Main,
        children: [{
                path: '/',
                component: Home,
                name: '首页',
            },
            {
                path: '/home/info',
                component: Info,
                name: 'info'
            }
        ]
    },
    {
        path: '/category',
        component: () =>
            import('../views/category.vue'),
        name: 'category'
    },
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/',
        component: Main,
        children: [{
            path: '/appointment/appointment',
            component: () =>
                import('../views/appointment/appointment.vue')
        }, ]
    },
    {
        path: '/',
        component: Main,
        children: [{
            path: '/appointmentList/appointmentList',
            component: () =>
                import('../views/appointmentList/appointmentList.vue')
        }, ]
    },
    {
        path: '/',
        component: Main,
        children: [{
            path: '/project/project',
            component: () =>
                import('../views/project/project.vue')
        }, ]
    },
    {
        path: '/',
        component: Main,
        children: [{
            path: '/instrument/instrument',
            component: () =>
                import('../views/instrument/instrument.vue')
        }, {
            path: '/instrument/instrumentTime',
            component: () =>
                import('../views/instrument/instrumentTime.vue')
        }, ]
    },
    {
        path: '/',
        component: Main,
        children: [{
            path: '/part/part',
            component: () =>
                import('../views/part/part.vue')
        }, ]
    },
    {
        path: '/',
        component: Main,
        children: [{
            path: '/account/account',
            component: () =>
                import('../views/account/account.vue')
        }, ]
    },
    {
        path: '/',
        component: Main,
        children: [{
                path: '/questionnaire/bjQuestion',
                component: () =>
                    import('../views/questionnaire/bjQuestion.vue')
            },
            {
                path: '/questionnaire/wzQuestion',
                component: () =>
                    import('../views/questionnaire/wzQuestion.vue')
            },
            {
                path: '/questionnaire/shQuestion',
                component: () =>
                    import('../views/questionnaire/shQuestion.vue')
            },
            {
                path: '/questionnaire/question',
                component: () =>
                    import('../views/questionnaire/question.vue')
            },
            // {
            //     path: '/questionnaire/code',
            //     component: () =>
            //         import('../views/questionnaire/code.vue')
            // },
        ]
    },

    {
        path: '/',
        component: Main,
        children: [{
            path: '/user/user',
            component: () =>
                import('../views/user/user.vue')
        }, ]
    },
    {
        path: '/',
        component: Main,
        children: [{
            path: '/roster/roster',
            component: () =>
                import('../views/roster/roster.vue')
        }, ]
    },
    {
        path: '/',
        component: Main,
        children: [{
                path: '/role/roleManagement',
                component: () =>
                    import('../views/role/roleManagement.vue')
            }, {
                path: '/role/webUser',
                component: () =>
                    import('../views/role/webUser.vue')
            },

        ]
    },
    {
        path: '/',
        component: Main,
        children: [{
                path: '/scanCode/scanList',
                component: () =>
                    import('../views/scanCode/scanList.vue')
            },

        ]
    },
    {
        path: '/',
        component: Main,
        children: [{
                path: '/scanCode/scanAccount',
                component: () =>
                    import('../views/scanCode/scanAccount.vue')
            },

        ]
    },
    {
        path: '/',
        component: Main,
        children: [{
                path: '/draftBox/draftBox',
                component: () =>
                    import('../views/draftBox/draftBox.vue')
            },

        ]
    },
    {
        path: '/',
        component: Main,
        children: [{
                path: '/appointmentTimes/appointmentTimes',
                component: () =>
                    import('../views/appointmentTimes/appointmentTimes.vue')
            },

        ]
    },
    {
        path: '/',
        component: Main,
        children: [{
            path: '/customerReception/nurseAll/nurse',
            component: () =>
                import('../views/customerReception/nurseAll/nurse.vue')
        }, {
            path: '/customerReception/customers/service',
            component: () =>
                import('../views/customerReception/customers/service.vue')
        }, {
            path: '/customerReception/frontAll/frontDesk',
            component: () =>
                import('../views/customerReception/frontAll/frontDesk.vue')
        }, {
            path: '/customerReception/receptionAll/reception',
            component: () =>
                import('../views/customerReception/receptionAll/reception.vue')
        }, {
            path: '/customerReception/serviceAll/serviceStatus',
            component: () =>
                import('../views/customerReception/serviceAll/serviceStatus.vue')
        }, {
            path: '/customerReception/punchStatus',
            component: () =>
                import('../views/customerReception/punchStatus.vue')
        }, ]
    },
    {
        path: '/',
        component: Main,
        children: [{
                path: '/registrationForm/registration',
                component: () =>
                    import('../views/registrationForm/registration.vue')
            },
            {
                path: '/registrationForm/injection',
                component: () =>
                    import('../views/registrationForm/injection.vue')
            },
            {
                path: '/registrationForm/dermatology',
                component: () =>
                    import('../views/registrationForm/dermatology.vue')
            },
            {
                path: '/registrationForm/consumables',
                component: () =>
                    import('../views/registrationForm/consumables.vue')
            },
            {
                path: '/registrationForm/logData',
                component: () =>
                    import('../views/registrationForm/logData.vue')
            },
            {
                path: '/registrationForm/setSurgical',
                component: () =>
                    import('../views/registrationForm/setSurgical.vue')
            },
            {
                path: '/registrationForm/setSkin',
                component: () =>
                    import('../views/registrationForm/setSkin.vue')
            },
            {
                path: '/registrationForm/setProduction',
                component: () =>
                    import('../views/registrationForm/setProduction.vue')
            },
            {
                path: '/registrationForm/setDiagnosis',
                component: () =>
                    import('../views/registrationForm/setDiagnosis.vue')
            },

        ]
    },
]

const router = new VueRouter({
    routes,
    mode: 'hash'
})

export default router